angular.
module("dx.webapp.examDuration").
factory("dxConvertDuration", function convertDurationService() {
	"use strict";

	function convertTimeToNs(hours, minutes) {
		return (hours * 60 + minutes) * 60 * Math.pow(10, 9);
	}

	function convertNsToTime(ns) {
		var totalMinutes = ns / (60 * Math.pow(10, 9));
		return {
			minutes: totalMinutes % 60,
			hours: (totalMinutes - (totalMinutes % 60)) / 60,
		};
	}

	return {
		convertTimeToNs: convertTimeToNs,
		convertNsToTime: convertNsToTime,
	};
});
